module.exports = __webpack_public_path__ + "static/media/lepoapp.15fac892.svg";